import { ValidationService } from './../../../../services/core/validation.service';
import { CookieService } from './../../../../services/core/cookie/cookie.service';
//Angular
import { Component, OnInit, OnDestroy, ViewContainerRef, Compiler, ViewChild, ElementRef, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Mappings } from "../../../../shared/mapping";

//Services
import { RegisterService } from "./../../../../services/cms/register.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { Configuration } from "../../../../models/core/configuration";
import { CompanyService } from "../../../../services/core/company.service";
import { ConfigurationService } from "../../../../services/core/configuration.service";
import { RoutesService } from "../../../../services/core/routes.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';

//Models
import { Register } from "./../../../../models/cms/register";
import { UserType } from "./../../../../models/cms/user-type";
import { SeoViewModel } from "./../../../../models/core/seo";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';
import { Subscription } from "rxjs/Subscription";
import { CheckIfExistService } from '../../../../services/cms/check-existence.service';
import { AuthService } from '../../../../services/core/auth.service';
import { LoginService } from '../../../../services/cms/login.service';
import { DOCUMENT } from '@angular/platform-browser';



@Component({
    template: ""
})

export class RegisterComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private languageService: LanguageService,
            private registerService: RegisterService,
            private route: ActivatedRoute,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    lang: string = this.languageService.getLongLang();

    subManager = new Subscription();
    ngOnInit() {

        let isQuickRegistration = this.route.snapshot.queryParams["quickRegistration"] || false;
        let registerSub = this.registerService.getRegisterPageData(this.lang).subscribe(result => {
             if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (this.isBrowser) {
                if (!result.IsActiveQuickRegistration) {
                    isQuickRegistration = false;
                }

                //Creating subcomponent whith the register result information to inject
                let subComponent = this.createSubComponent(result, isQuickRegistration);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.userRegistrationId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(registerSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(result: any, isQuickRegistrationActive: boolean) {
        @Component({
            template: result.TemplateHtml
        })


        class ChildComponent implements OnInit, OnDestroy {

            @ViewChild('submitButton') submitButton: ElementRef;

            constructor
                (
                    private seoService: SeoService,
                    private registerService: RegisterService,
                    private languageService: LanguageService,
                    private router: Router,
                    private mappings: Mappings,
                    private checkExists: CheckIfExistService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private companyService: CompanyService,
                    private configurationService: ConfigurationService,
                    private routeService: RoutesService,
                    private breadcrumbsService: BreadcrumbsService,
                    private _compiler: Compiler,
                    private route: ActivatedRoute,
                    private routesService: RoutesService,
                    private validationService: ValidationService,
                    @Inject('CookieService') private cookie: CookieService,
                    private authService: AuthService,
                    private loginService: LoginService
                ) { }

            private isCaptchaInvalid: boolean;
            public verified: any;
            public siteKey: string = "6LcTlhYTAAAAAADnzMzRAmFtNPyHxr-IvkwXfCZ1";
            public theme: string = "light";
            private model: Register;
            private customerTypeList: Array<UserType>;
            private isRegisterFailed: boolean;
            private seoInfo: SeoViewModel = result.SeoInformation;
            private emailError: boolean = false;
            private passwordError: boolean = false;
            private success: boolean = false;
            private load: boolean = false;
            private emailValid: any;
            private validEmail: string = "";
            private pageIsInit: boolean = false;
            private pageIsOnDestroy: boolean = false;
            private showEmailInvalid: boolean = false;
            private showPivaInvalid: boolean = false;
            private showCFInvalid: boolean = false;
            private subscription: Subscription;
            private isValidCodDest: string = "";
            private isValidPecEmail: string = "";
            public isQuickRegistration: boolean = isQuickRegistrationActive;
            public configuration: Configuration;
            public quickRegisteredUser: Object = null;

            private lang: string = this.languageService.getLongLang();

            private breadcrumbs: Breadcrumbs[] = result.BreadcrumbsInfo;
            private registerViaFbData = this.registerService.getFacebookLoginData();
            private disableFbDataFields: boolean = false;

            private cartRoute = this.routeService.getRoutePath('CARRELLO');
            private homepageRoute = this.routeService.getRoutePath('HOME');
            private pageFrom: string = "";

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                let paramsSub = this.route.params.subscribe(params => {
                    let paramPageFrom = params['pagefrom'];

                    if (paramPageFrom !== undefined) {
                        this.pageFrom = paramPageFrom;
                    }
                });

                this.subManager.add(paramsSub);

                this.model = new Register();
                this.customerTypeList = result.UserTypes;

                this.model.CustomerGroup = "5";
                this.model.CustomerType = "";
                this.model.PecEmail = "";
                this.model.CodiceDestinatario = "";

                //-- If the user used quick registration feature, we can get it's data from the cookies
                if (this.isQuickRegistration) {
                    this.quickRegisteredUser = this.cookie.getObject("QuickRegisterUser");
                    this.setModelDataFromCookies();
                }

                this.showEmailInvalid = false;

                if (this.registerViaFbData) {
                    this.model.CustomerGroup = "4";

                    this.setModelDataFromFb(this.registerViaFbData);
                }

                this.isCodDestRequired()
                this.isPecEmailRequired()

                this.configurationService.getConfiguration(this.lang).subscribe(resultConfiguration => {
                    let companySub = this.companyService.getCompany().subscribe(resultCompany => {
                        {
                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_RAGIONE_SOCIALE}').join(resultCompany.Name);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_INDIRIZZO}').join(resultCompany.StreetAddress);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CAP}').join(resultCompany.PostalCode);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_CITTA}').join(resultCompany.City);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_PROVINCIA}').join(resultCompany.Province);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_TELEFONO}').join(resultCompany.Phone);
                            }

                            if (resultConfiguration.Privacy.indexOf('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}') > -1) {
                                resultConfiguration.Privacy = resultConfiguration.Privacy.split('{TAG_CONFIGURAZIONE_INFO_AZIENDA_EMAIL}').join(resultCompany.Email);
                            }
                        }

                        this.configuration = resultConfiguration;
                    });

                    this.subManager.add(companySub);
                });
            };

            setModelDataFromCookies() {
                if (!this.quickRegisteredUser)
                    return;

                this.model.EmailRegister = this.quickRegisteredUser['QuickEmailUser'];
                this.model.EmailRepeat = this.quickRegisteredUser['QuickEmailUser'];
                this.model.CustomerGroup = this.quickRegisteredUser['QuickClientType'];
                this.model.Telephone = this.quickRegisteredUser['QuickTelephone'];

                let isQuickRegistered = this.cookie.get("IsQuickRegistered") ? Boolean(this.cookie.get("IsQuickRegistered")) : false;
                this.model.IsQuickRegistered = isQuickRegistered;

                //-- If customer group is privato or associazione, then CF was already set during registration, else Partita Iva was set
                if (this.model.CustomerGroup === '4' || this.model.CustomerGroup === '7') {
                    this.model.CF = this.quickRegisteredUser['QuickCodiceFiscale'];
                }
                else {
                    this.model.Piva = this.quickRegisteredUser['QuickPartitaIva'];
                }
            }

            disableFieldsFilledFromFbData() {
                this.disableFbDataFields = true;
            }

            setModelDataFromFb(reg: any) {
                this.model.Name = reg.Name;
                this.model.SubName = reg.SubName;
                this.model.EmailRegister = reg.Email;
                this.model.EmailRepeat = reg.Email;
                this.model.Password = reg.Password;
                this.model.PasswordRepeat = reg.Password;

                this.disableFieldsFilledFromFbData();
            }

            //adding all scripts and elements connected to address verification feature                
            addAddressVerificationScripts(addressKey: string) {
                let suggest = "<script type=\"text/javascript\" id=\"suggestId\" src=\"/template/b2c/template01/layout/js/suggest.js\"></script>";
                let address = "<script id=\"addressVerificationId\" type=\"text/javascript\" title=" + addressKey + " src=\"/template/b2c/template01/layout/js/adress-verification.js?v=1\"></script>";
                let jquery = "<script type=\"text/javascript\" id=\"jqueryId\" src=\"/template/b2c/template01/layout/vendor/jquery/jquery.min.js\"></script>";

                $('body > universal-script').before(suggest);
                $('body > universal-script').before(jquery);
                $('body > universal-script').before(address);
            }

            //removing all scripts and elements connected to address verification feature                            
            removeAddressVerificationScripts(addressKey: string) {
                $("#suggestId").remove();
                $("#jqueryuicss").remove();
                $("#jqueryuijs").remove();
                $("#suggestcss").remove();
                $("#initui").remove();
                $("#inituicf").remove();
                $("#ui-id-1").remove();
                $("#ui-id-2").remove();
                $("div").remove(".ui-helper-hidden-accessible");

                $("#jqueryId").remove();
                $("#addressVerificationId").remove();
            }

            checkAddressValidation() {
                this.model.Prov = $("#Prov").val();
                this.model.Cap = $("#Cap").val();
                this.model.City = $("#City").val();
            }

            setAddressValue() {
                let streetTypeId = $("#streetTypeId").val();
                let street = $("#Address").val();

                if (streetTypeId != null && streetTypeId != "") {
                    this.model.Address = streetTypeId + " " + street;
                }
                else {
                    this.model.Address = street;
                }
            }

            isDisabled(form) {
                let res: boolean = false;

                if (this.disableFbDataFields) {
                    if (form.valid && this.model.EmailRegister == this.model.EmailRepeat && this.model.Password == this.model.PasswordRepeat) {
                        res = true;
                    }
                    else {
                        res = false;
                    }
                }
                else if (this.isQuickRegistration && this.quickRegisteredUser) {
                    if (form.valid && this.model.EmailRegister == this.model.EmailRepeat) {
                        res = true;
                    }
                    else {
                        res = false;
                    }
                }
                else {
                    if (form.valid && this.model.EmailRegister == this.model.EmailRepeat && this.model.Password == this.model.PasswordRepeat
                        && this.emailValid == true && this.showCFInvalid == false) {
                        if (this.model.CustomerGroup != '4') {
                            if (this.showPivaInvalid == false) {
                                res = true;
                            }
                            else {
                                res = false;
                            }
                        }
                        else {
                            res = true;
                        }
                    }
                    else {
                        res = false;
                    }
                }

                return res;
            }

            //checking after changing of focus if the email entered in form already exists in database
            checkEmail(form) {
                let email = this.model.EmailRegister;

                if (form.controls.EmailRegister.valid) {
                    if (this.disableFbDataFields == false) {
                        let checkEmailSub = this.checkExists.checkIfEmailExistsInDb(email)

                            .subscribe(result => {
                                this.showEmailInvalid = false;

                                if (result == 1) {
                                    this.emailValid = true;
                                    this.validEmail = "ng-valid";
                                }
                                else {
                                    this.emailValid = false;
                                    this.validEmail = "ng-invalid";
                                    this.showEmailInvalid = true;
                                }
                            })

                        this.subManager.add(checkEmailSub);
                    }

                }
                else {
                    this.emailValid = false;
                    this.validEmail = "ng-invalid";
                    this.showEmailInvalid = false;
                }
            }

            //checking after changing of focus if the partita iva entered in form already exists in database
            checkPiva(field) {
                let piva = this.model.Piva;

                if (field.valid) {
                    if (!field.value || !field.value.trim())
                        return;

                    if (this.disableFbDataFields == false) {
                        this.checkExists.checkIfPartitaIvaExistsInDb(piva)
                            .subscribe(result => {
                                this.showPivaInvalid = false;

                                if (result == 1) {
                                    this.showPivaInvalid = false;
                                }
                                else {
                                    if (this.model.CustomerGroup !== '7') {
                                        this.showPivaInvalid = true;
                                    }
                                }
                            })
                    }

                }
                else {
                    if (this.model.CustomerGroup !== '7') {
                        this.showPivaInvalid = true;
                    }
                }
            }

            //checking after changing of focus if the codice fiscale entered in form already exists in database
            checkCF(field) {
                let piva = this.model.CF;

                //-- Check if the CF already exists only when group is privato
                if (this.model.CustomerGroup === '4') {
                    if (field.valid) {
                        if (this.disableFbDataFields == false) {
                            this.checkExists.checkIfCodiceFiscaleExistsInDb(piva)
                                .subscribe(result => {
                                    this.showCFInvalid = false;

                                    if (result == 1) {
                                        this.showCFInvalid = false;
                                    }
                                    else {
                                        this.showCFInvalid = true;
                                    }
                                })
                        }

                    }
                    else {
                        this.showCFInvalid = true;
                    }
                }
                else {
                    this.showCFInvalid = false;
                }
            }

            onSubmit() {
                //after submiting form, we are disabling a button until we get a response
                this.submitButton.nativeElement.disabled = true;

                this.load = true;
                this.model.Language = this.languageService.getLongLang();

                //converting CAP field to string
                this.model.Cap = this.model.Cap.toString();

                //concating of address street and number to one model field
                this.model.Address = this.model.Address + " " + this.model.AddressNumber;

                if (this.registerViaFbData != null && this.registerViaFbData != undefined) {
                    this.model.IsCompletedRegistration = false;
                }

                let sendInfoSub = this.registerService.sendInfoRequest(this.model)
                    .subscribe(result => {
                        if (result["selected"]) {
                            if (this.isQuickRegistration) {
                                let authSub = this.loginService.authentificateUser(this.model.EmailRegister, this.model.Name, this.model.Name).subscribe(response => {
                                    this.cookie.remove('QuickRegisterUser');
                                    this.cookie.remove('IsQuickRegistered');
                                    this.authService.Login(response.Id_User_Dettail, response.Name);
                                    this.navigateToCorespondingPage();
                                });
                            }
                            else {
                                this.navigateToCorespondingPage();
                            }

                        }
                        else {
                            this.emailError = false;
                            this.passwordError = false;
                            this.isRegisterFailed = true;
                            this.load = false;
                            this.success = false;
                        }
                    })

                this.subManager.add(sendInfoSub);
            }

            navigateToCorespondingPage() {
                if (this.pageFrom == "cart") {
                    this.router.navigate(this.routeService.getRoutePath('CARRELLO'));
                }
                else {

                    let registrationCompletePage: string[] = this.routesService.getRoutePath('REGISTRATION - COMPLETE')[0];
                    this.router.navigate([registrationCompletePage]);
                    this.emailError = false;
                    this.passwordError = false;
                    this.isRegisterFailed = false;
                    this.load = false;
                    this.success = true;
                }
            }

            setVerified(data) {
                this.isCaptchaInvalid = data;
            }

            onCustomerTypeChange(value) {
                this.model.CustomerType = value;
            }

            onCustomerGroupChange(value) {
                this.model = new Register();
                this.model.CustomerGroup = value;

                if (this.registerViaFbData != null && this.registerViaFbData != undefined) {
                    this.setModelDataFromFb(this.registerViaFbData);
                }
            }

            isCodDestRequired() {
                let retVal = false;
                if (this.model.CustomerGroup != "4") {
                    if (this.model.PecEmail == "" || this.model.PecEmail == undefined) {
                        retVal = true;
                    }
                }

                return retVal;
            }

            isPecEmailRequired() {
                let retVal = false;
                if (this.model.CustomerGroup != "4") {
                    if (this.model.CodiceDestinatario == "" || this.model.CodiceDestinatario == undefined) {
                        retVal = true;
                    }
                }

                return retVal;
            }

            //validation of phone numbers, disable writing any characters in input except of numbers
            validatePhone(event: any) {
                this.validationService.validatePhoneNumber(event);
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                $('.popovers').popover();

                if (result.isActiveAddressVerificationModule) {
                    let addressVerificationKey = result.AddressVerificationCode;
                    if (addressVerificationKey != null && addressVerificationKey != undefined && addressVerificationKey != "") {
                        this.addAddressVerificationScripts(addressVerificationKey);
                        $("#Cap").prop('disabled', true);

                    }
                }
                else {
                    $("#Cap").prop('disabled', false);
                }

                //hiding of loading panel after we get all data we need
                this.routeService.hidePageLoader();

                this.pageIsInit = true;
            }

            ngOnDestroy() {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }

                //this method is removing all scripts and elements connected to address verification feature
                let addressVerificationKey = result.AddressVerificationCode;
                this.removeAddressVerificationScripts(addressVerificationKey);

                this.subManager.unsubscribe();

                // this.registerService.setFacebookLoginData(null);
                this.pageIsOnDestroy = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/user/sys/register.component.ts